import axios from "axios";

interface LoginRequest {
  userName: string;
  password: string;
  code: number;
}

interface LoginResponse {
  data: {
    claims: string[];
    token: string;
    expiration: string;
    refreshToken: string;
  };
  success: boolean;
  message: string;
}

export async function login(data: LoginRequest) {
  return axios
    .post<LoginResponse>("/auth/login", {
      code: data.code,
      userName: data.userName,
      password: data.password,
    })
    .then((res) => {
      if (res.data.success) {
        return res.data;
      }
      throw new Error(res.data.message);
    });
}

interface RefreshTokenResponse {
  data: {
    token: string;
    expiration: string;
    refreshToken: string;
  };
  success: boolean;
  message: string;
}

export async function getRefreshToken(refreshToken: string) {
  return axios
    .post("/auth/refresh-token", {
      refreshToken,
    })
    .then((res) => res.data as RefreshTokenResponse);
}

interface CheckLocationUserPinRequest {
  LocationId: string;
  UserId: string;
  UserLocationPin: string;
}

export async function checkLocationUserPin(data: CheckLocationUserPinRequest) {
  return axios
    .post("/CompanyLocationUsers/checklocationuserpin", data)
    .then((res) => res.data);
}

export function updateUserPassword(data: { userId: string; password: string }) {
  return axios.put("/Auth/user-password", data).then((res) => res.data);
}

export function updateUserPasswordWithOldPassword(data: {
  userId: string;
  password: string;
  oldPassword: string;
}) {
  return axios
    .put("/Auth/user-password-with-old", data)
    .then((res) => res.data);
}
